// 📁 src/pages/MarketResearch/frameworks/LeanCanvas.jsx

import React,{useEffect,useState} from "react";
import {useLocation,useNavigate} from "react-router-dom";

import axios from "../../../utils/axiosInstance";
import {useIdea} from "../../../context/IdeaContext";

import ModuleHeader from "../../../components/ModuleHeader";
import {buildMDIHPdfName} from "../../../utils/pdfNaming";

const LeanCanvas=()=>{

const {state}=useLocation();
const navigate=useNavigate();
const {selectedIdea}=useIdea();

/* ================= IDEA RESOLUTION ================= */

const ideaId=
state?.ideaId ||
selectedIdea?.ideaId ||
null;

const ideaTitle=

    selectedIdea?.ideaTitle ||

    selectedIdea?.title ||

    state?.ideaTitle ||

    localStorage.getItem("activeIdeaTitle") ||

    "Startup Idea";

const ideaText=
state?.ideaText ||
state?.idea ||
selectedIdea?.description ||
selectedIdea?.title ||
"";

const recordId=
state?.marketResearchRecordId ||
state?.recordId ||
null;

/* ================= STATE ================= */

const [result,setResult]=useState(null);
const [error,setError]=useState(null);
const [loading,setLoading]=useState(false);

const [loadingExport,setLoadingExport]=useState(false);

const [showPopup,setShowPopup]=useState(false);
const [motivationalMessage,setMotivationalMessage]=useState(null);

useEffect(()=>{

    if(selectedIdea?.ideaTitle){

    localStorage.setItem(
    "activeIdeaTitle",
    selectedIdea.ideaTitle
    );

    }

    },[selectedIdea]);
/* ================= FETCH ================= */

useEffect(()=>{

if(!ideaId || !recordId){

navigate("/market-research");
return;

}

const fetchLeanCanvas=async()=>{

setLoading(true);
setError(null);

try{

const res=await axios.post(

"/api/market-research/framework",

{
framework:"lean-canvas",
idea:ideaText,
ideaId,
recordId
}

);

if(res.data?.result){

setResult(res.data.result);
fetchMotivation();

}
else{

setError("Failed to fetch Lean Canvas analysis");

}

}catch{

setError("Failed to generate Lean Canvas analysis");

}
finally{

setLoading(false);

}

};

const fetchMotivation=async()=>{

const finalIdea=
ideaText?.trim() ||
selectedIdea?.description ||
selectedIdea?.title ||
"";

if(!finalIdea) return;

try{

const res=await axios.post(

"/api/motivation",

{
module:"Lean Canvas",
idea:finalIdea
}

);

if(res.data?.success){

setMotivationalMessage(res.data.message);
setShowPopup(true);

}

}catch{}

};

fetchLeanCanvas();

},[ideaId,recordId,ideaText,navigate]);

/* ================= PDF ================= */

const handleDownload=async()=>{

if(!result) return;

try{

setLoadingExport(true);

const token=
localStorage.getItem("token");

const response=
await axios.post(

"/api/pdf/market-research",

{
ideaId,
framework:"LEAN"
},

{
headers:{
Authorization:`Bearer ${token}`
},
responseType:"blob"
}

);

const blob=
new Blob(
[response.data],
{type:"application/pdf"}
);

const url=
window.URL.createObjectURL(blob);

const link=
document.createElement("a");

link.href=url;

link.download=
buildMDIHPdfName(
ideaTitle,
"MarketResearch_LEAN"
);

document.body.appendChild(link);

link.click();

link.remove();

}
catch(err){

console.error(err);

alert("Failed to download PDF");

}
finally{

setLoadingExport(false);

}

};

/* ================= NAVIGATION ================= */

const handleMVP=()=>{

navigate(
"/mvp-planner",
{state:{ideaId,ideaText}}
);

};

const handleLearnMore=()=>{

navigate(
"/learning-mentorship",
{state:{topic:"Lean Canvas"}}
);

};

/* ================= LABEL FORMATTER ================= */

const formatLabel=(key)=>{

return key
.replace(/([A-Z])/g," $1")
.replace(/^./,(str)=>str.toUpperCase());

};

/* ================= UI ================= */

return(

<div className="bg-slate-50 min-h-screen">

<div className="max-w-6xl mx-auto px-6 py-10 space-y-8 relative">

{/* MODULE HEADER */}

<ModuleHeader

title="Lean Canvas"

subtitle="Structure your opportunity into a validated execution model."

currentModule="marketResearch"

ideaTitle={ideaTitle}

isLoadedFromDB={true}

/>

{/* ACTIVE IDEA */}

<div className="text-sm text-gray-500 border-b border-slate-200 pb-4">

<b>Startup:</b> {ideaTitle}

</div>

{/* ERROR */}

{error &&(

<div className="text-red-600 text-sm">

⚠️ {error}

</div>

)}

{/* LOADING */}

{loading && !result &&(

<p className="text-sm text-slate-600">

Generating Lean Canvas analysis...

</p>

)}

{/* RESULTS */}

{result &&(

<>

<div className="space-y-6 border-b border-slate-200 pb-6">

<h2 className="text-2xl font-semibold text-blue-900">

Lean Canvas Breakdown

</h2>

<div className="grid md:grid-cols-2 gap-6 text-sm text-slate-700">

{Object.entries(result).map(
([key,value])=>(

<div
key={key}
className="bg-white rounded-xl p-5 shadow-sm border border-slate-200"
>

<p className="font-semibold text-blue-900 mb-2">

{formatLabel(key)}

</p>

<p>

{value || "Analysis unavailable"}

</p>

</div>

)
)}

</div>

<div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">

✅ Lean Canvas Analysis Completed

</div>

</div>

{/* CTA */}

<div className="pt-6 border-t border-slate-200 space-y-3">

<h3 className="text-lg font-semibold text-blue-900">

Ready to Operationalize This Blueprint?

</h3>

<p className="text-sm text-slate-600 max-w-2xl">

Use this Lean Canvas to define MVP scope,
refine positioning and move toward execution.

</p>

<button

onClick={handleMVP}

className="bg-purple-600 text-white px-7 py-2.5 rounded-lg text-sm font-semibold hover:bg-purple-700 transition"

>

Move to MVP Planning →

</button>

{/* SECONDARY */}

<div className="mt-4 flex flex-wrap gap-3 text-sm">

<button

onClick={()=>

navigate(
"/market-research",
{state:{ideaId,ideaText,recordId}}
)

}

className="text-slate-600 hover:text-slate-800 underline"

>

🔁 Explore More Frameworks

</button>

<button

onClick={handleDownload}

className="text-blue-600 hover:text-blue-800 underline"

>

{loadingExport ?

"Generating PDF..."

:

"📄 Download Lean Canvas"

}

</button>

<button

onClick={handleLearnMore}

className="text-indigo-600 hover:text-indigo-800 underline"

>

🎓 Learn More About Lean Canvas

</button>

</div>

</div>

</>

)}

{/* MOTIVATION */}

{showPopup && motivationalMessage &&(

<div className="fixed bottom-6 right-6 bg-yellow-100 border border-yellow-300 text-yellow-900 px-5 py-4 rounded-lg shadow-lg max-w-sm">

<p className="font-semibold mb-1 text-sm">

{motivationalMessage.title}

</p>

<p className="text-xs">

{motivationalMessage.message}

</p>

<button

className="mt-2 text-xs text-blue-700 underline"

onClick={()=>setShowPopup(false)}

>

{motivationalMessage.ctaText || "Continue"}

</button>

</div>

)}

</div>

</div>

);

};

export default LeanCanvas;